export default "__VITE_ASSET__C7lVVR4N__"